/**
 * Enumeration for different types of assignment for objects to drivers describing the way the assignment has been set.
 *
 * @readonly
 * @enum {string}
 */
export const ObjectDriverAssignmentTypes = Object.freeze({
    DEVICE: 'DEVICE',
    MANUAL: 'MANUAL'
})
